import { isDevDebugVisible } from "@/hooks/useDevDebugVisible/helpers"
import { useAppSelector } from "@/store"
import { AppSelectors } from "@/store/slices/app"

export const useDevDebugVisible = (isDebug: boolean): boolean => {
  const isDevBuild = useAppSelector(AppSelectors.selectIsDevEnv())
  return isDevDebugVisible({ isDevBuild, isDebug })
}
